import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Career from './pages/Career';
import Contact from './pages/Contact';
import Products from './pages/Products';
import ServiceDetails from "./pages/ServicesDetails";
import Blog from './pages/blog';
import BlogSingle from "./pages/BlogSingle";
import Sitemap from "./pages/sitemap";
import CustomSoftwarePage from './components/CustomSoftware';
import WebApplicationDevelopmentPage from './components/WebApps,';
import MobileAppDevelopmentPage from './components/MobileApps';
import SaaSdevelopmentPage from './components/saas';
import APIIntegrationPage from './components/APIIntegration';
import WebsiteDevelopmentPage from './components/WebsiteDevelopment';
import EcommerceDevelopmentPage from './components/E-commerce';
import SEOPage from './components/SEO';
import DigitalMarketingPage from './components/DigitalMarketing';
import HaryanaSoftwareCompanyPage from './components/harayan';
import PunjabPage from './components/punjab';
import UttarPradeshPage from './components/uttarpradesh';
import RajasthanPage from './components/Rajasthan';
import DelhiPage from './components/delhi';
import GurugramPage from './components/Gurugram';
import NoidaPage from './components/noida';
import JaipurPage from './components/jaipur';
import LucknowPage from './components/Lucknow';
import SirsaPage from './components/sirsa';
import GurukulERPPage from './components/gurukulerp';
import BeaconTrackPage from './components/BeaconTrack';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80
    });
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <div className="h-[110px] md:h-[120px]"></div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceName" element={<ServiceDetails />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Products />} />
        
        {/* BLOG ROUTES */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogSingle />} />
         <Route path="/Sitemap" element={<Sitemap />} />
         <Route path="/software-as-a-service-development" element={<SaaSdevelopmentPage />} />
         <Route path="/Custom-Software-Page" element={<CustomSoftwarePage />} />
         <Route path="/web-application-development" element={<WebApplicationDevelopmentPage />} />
         <Route path="/mobile-app-development" element={<MobileAppDevelopmentPage />} />
         <Route path="/api-development" element={<APIIntegrationPage />} />
         <Route path="/website-development" element={<WebsiteDevelopmentPage />} />
         <Route path="/ecommerce-development" element={<EcommerceDevelopmentPage />} />
         <Route path="/seo-services" element={<SEOPage /> } />
         <Route path="/digital-marketing" element={<DigitalMarketingPage /> } />
         <Route path="/software-development-haryana" element={<HaryanaSoftwareCompanyPage />} />
         <Route path="/software-development-punjab"  element={<PunjabPage />} />
         <Route path="/software-development-uttarpradesh" element={<UttarPradeshPage />} />
         <Route path="/software-development-rajasthan" element={<RajasthanPage />} />
         <Route path="/software-development-delhi" element={<DelhiPage />} />
         <Route path="/software-development-gurugram/haryana" element={<GurugramPage />} />
         <Route path="/software-development-noida/uttarpradesh" element={<NoidaPage />} />
         <Route path="/software-development-jaipur/rajasthan" element={<JaipurPage />} />
         <Route path="/software-development-lucknow/uttarpradesh" element={<LucknowPage />} />
         <Route path="/software-development-sirsa/haryana" element={<SirsaPage />} />
         <Route path="/school-erp-software" element={<GurukulERPPage />} />
         <Route path="/Beacon-Track-Billing-Software" element={<BeaconTrackPage />} />
         

         
      </Routes>

      <ScrollToTop />
      <Footer />
    </div>
  );
}

export default App;